module.exports = __webpack_public_path__ + "img/slider-1.857c339.png";